'use client'

import { useAuthContext } from '@/features/auth/contexts/AuthContext'
import { Button } from '@/shared/ui/Button'

type ResetPasswordButtonProps = React.ComponentProps<typeof Button>

export function ResetPasswordButton({
  children,
  ...props
}: ResetPasswordButtonProps) {
  const { isLoading } = useAuthContext()

  return (
    <Button type="submit" disabled={isLoading} {...props}>
      {isLoading ? (
        <>
          <span>
            <i className="fad fa-spinner-third fa-spin" />
          </span>{' '}
          Salvando...
        </>
      ) : (
        children ?? 'Salvar nova senha'
      )}
    </Button>
  )
}
